import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "edit-text-modal-title"
};
const _hoisted_2 = {
  class: "edit-text-modal-top"
};
const _hoisted_3 = {
  class: "image-box"
};
const _hoisted_4 = {
  class: "text-box"
};
const _hoisted_5 = {
  class: "sku-and-asin"
};
const _hoisted_6 = {
  class: "product-name"
};
const _hoisted_7 = {
  class: "button-box"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "edit-text-modal-body"
};
const _hoisted_11 = {
  class: "edit-text-modal-bottom"
};
const _hoisted_12 = {
  class: "button-box",
  style: {
    "gap": "28px"
  }
};
const _hoisted_13 = {
  key: 0,
  class: "dotted-line-container"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "dotted-line"
}, [/*#__PURE__*/_createElementVNode("div", null, "or")], -1);
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "button-box"
};
const _hoisted_17 = {
  class: "header"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "body"
}, " Along with this product the change will reflect on all other product with the same parent ASIN. ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_edit_text_modal_content = _resolveComponent("edit-text-modal-content");
  const _component_AppButton = _resolveComponent("AppButton");
  const _component_b_dropdown_text = _resolveComponent("b-dropdown-text");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $options.modal = $event),
    "hide-footer": "",
    "hide-header": "",
    "no-close-on-backdrop": "",
    "no-fade": "",
    class: "edit-text-modal"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_b_img, {
      src: $props.image,
      alt: "Image",
      class: "custom-img"
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.asin) + " - " + _toDisplayString($props.sku), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($props.name), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      class: _normalizeClass(['compare-btn', {
        show_comparism: $data.show_comparism
      }, {
        comparison_loading: $data.comparison_loading
      }]),
      onClick: _cache[0] || (_cache[0] = $event => $options.onCompareButtonClick())
    }, [!$data.comparison_loading ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($data.show_comparism ? "Hide Comparison" : "Show Comparison"), 1)) : _createCommentVNode("", true), $data.comparison_loading ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 1,
      icon: "loading",
      size: "16",
      color: "#736BC9",
      class: "icon-spin"
    })) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(['translate-btn', {
        show_translation: $data.show_translation
      }, {
        translation_loading: $data.translation_loading
      }]),
      onClick: _cache[1] || (_cache[1] = $event => $options.computeTranslations())
    }, [!$data.translation_loading ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($data.show_translation ? "Hide Translation" : "Show Translation"), 1)) : _createCommentVNode("", true), $data.translation_loading ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 1,
      icon: "loading",
      size: "16",
      color: "#736BC9",
      class: "icon-spin"
    })) : _createCommentVNode("", true)], 2)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_edit_text_modal_content, {
      modelValue: $options.valueModel,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.valueModel = $event),
      type: "omny",
      content_type: $props.type,
      isValid: $data.isValid,
      allowHtmlInputAndSpecialCharacters: $props.allowHtmlInputAndSpecialCharacters,
      character_range: $options.characterRangePerContentType,
      translation: $data.omny_translation,
      show_translation: $data.show_translation,
      show_comparism: $data.show_comparism,
      comparism: $data.omny_text_with_diffs,
      apply_keywords_loading: $data.apply_keywords_loading,
      onHide_comparism: _cache[3] || (_cache[3] = $event => $data.show_comparism = false),
      onApplyKeywords: $options.onApplyKeywords,
      onCheckIsValid: $options.checkIsValid
    }, null, 8, ["modelValue", "content_type", "isValid", "allowHtmlInputAndSpecialCharacters", "character_range", "translation", "show_translation", "show_comparism", "comparism", "apply_keywords_loading", "onApplyKeywords", "onCheckIsValid"]), _createVNode(_component_edit_text_modal_content, {
      type: "amazon",
      content_type: $props.type,
      original: $props.original,
      allowHtmlInputAndSpecialCharacters: $props.allowHtmlInputAndSpecialCharacters,
      character_range: $options.characterRangePerContentType,
      translation: $data.amazon_translation,
      show_translation: $data.show_translation,
      show_comparism: $data.show_comparism,
      comparism: $data.amazon_text_with_diffs
    }, null, 8, ["content_type", "original", "allowHtmlInputAndSpecialCharacters", "character_range", "translation", "show_translation", "show_comparism", "comparism"])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
      class: "cancel-btn",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.onCancel && $options.onCancel(...args))
    }, "Cancel"), $props.show_accept_amazon ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "accept-amazon-btn",
      onClick: _cache[5] || (_cache[5] = (...args) => $options.acceptAmazonAndSave && $options.acceptAmazonAndSave(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "accept-amazon"
    }), _createTextVNode(" Accept Amazon version & Save ")])) : _createCommentVNode("", true)]), $props.show_accept_amazon ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createVNode(_component_AppButton, {
      class: "save-btn",
      onClick: $options.onSubmit,
      disabled: !$data.isValid,
      style: _normalizeStyle($props.show_save_all_children ? 'border-radius: 8px 0px 0px 8px;' : 'border-radius: 8px;')
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "save"
      }), _createTextVNode(" Save ")]),
      _: 1
    }, 8, ["onClick", "disabled", "style"]), $props.show_save_all_children ? (_openBlock(), _createBlock(_component_b_dropdown, {
      key: 0,
      disabled: !$data.isValid,
      "no-caret": "",
      "toggle-class": "save-children-btn",
      class: "save-children",
      dropup: "",
      right: ""
    }, {
      "button-content": _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_app_icon, {
        icon: "save-children"
      }), _createVNode(_component_app_icon, {
        icon: "chevron-down-v2",
        color: "#C5C0FF"
      })])]),
      default: _withCtx(() => [_createVNode(_component_b_dropdown_text, {
        class: "dropdown-container"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = (...args) => $options.onSubmitAllChildren && $options.onSubmitAllChildren(...args))
        }, [_createElementVNode("div", _hoisted_17, " Save and apply changes to all " + _toDisplayString($props.children_num) + " children ", 1), _hoisted_18])]),
        _: 1
      })]),
      _: 1
    }, 8, ["disabled"])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["modelValue"]);
}